import React, { ChangeEvent, useEffect, useState, useContext } from "react";
import { Grid } from "@mui/material";
import Configurations from "./subviews/Configurations";
import Ordering from "./subviews/Ordering";
import Branding from "./subviews/Branding";
import { useTranslation } from "react-i18next";
import API from "api";
import { GlobalContext } from "context/Provider";
import Loader from "components/shared/Loader/Loader";
import Login from "../Login/Login";
import { StyledContainer, StyledHeader } from "./Admin.styled";
import { Routes, Route } from "react-router-dom";

export default function Admin() {
  const { t } = useTranslation();
  const { configDispatch } = useContext(GlobalContext);
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(
    sessionStorage.getItem("adminAuth") === "true"
  );
  const [contentLoaded, setContentLoaded] = useState<boolean>(false);

  useEffect(() => {
    API.kore.configurations
      .getConfigurations()
      .then((configs) => {
        delete configs.url;
        configDispatch({ type: "OPTIONS_UPLOAD", payload: configs });
        setTimeout(() => {
          setContentLoaded(true);
        }, 500);
      })
      .catch((configErrs) => console.log(configErrs));
  }, []);

  if (!isAuthenticated) {
    return <Login target="admin" />;
  }

  return contentLoaded ? (
    <Grid container>
      <Grid item xs={1} />
      <Grid item xs={10}>
        <StyledContainer>
          <StyledHeader>{t("u-admin-console")}</StyledHeader>
          <Routes>
            <Route path="configurations" element={<Configurations/>}/>
            <Route path="ordering" element={<Ordering/>}/>
            <Route path="branding" element={<Branding/>}/>
          </Routes>
        </StyledContainer>
      </Grid>
      <Grid item xs={1} />
    </Grid>
  ) : (
    <Loader />
  );
}
